module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('Tab', {
    attrs: {
      "tabList": _vm.tabList,
      "path": _vm.path
    }
  }, [_c('DataTablePage', {
    ref: "copyDateTable",
    attrs: {
      "slot": "copyDate",
      "mainColumn": "day",
      "longColumn": "",
      "title": "",
      "label": "计划任务",
      "labelName": "",
      "resource": _vm.resource,
      "toolbar": _vm.toolbar,
      "operation": _vm.operation,
      "operationWidth": 115,
      "filterFullList": _vm.filterFullList,
      "filterInitList": _vm.filterInitList,
      "tableData": _vm.tableData,
      "tableFullList": _vm.tableFullList,
      "tableInitList": _vm.tableInitList,
      "createList": _vm.createList,
      "updateList": _vm.updateList,
      "columns": _vm.columns
    },
    on: {
      "getRelation": _vm.getRelation
    },
    slot: "copyDate"
  }, [_c('div', {
    staticClass: "col-md-12",
    attrs: {
      "slot": "formTopSlot"
    },
    slot: "formTopSlot"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-form-label text-sm-right col-sm-3"
  }, [_vm._v("配置类型")]), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('el-switch', {
    ref: "settingType",
    attrs: {
      "on-text": "常规配置",
      "on-color": "#df9464",
      "on-value": "ordinary",
      "off-text": "高级配置",
      "off-color": "#409eff",
      "off-value": "senior",
      "width": 100
    },
    on: {
      "change": _vm.changeSwitch
    },
    model: {
      value: (_vm.actSwitchVal),
      callback: function($$v) {
        _vm.actSwitchVal = $$v
      },
      expression: "actSwitchVal"
    }
  })], 1)])])])]), _c('div', {
    staticClass: "formBox",
    attrs: {
      "slot": "freeze"
    },
    slot: "freeze"
  }, [_c('SmartForm', {
    ref: "freezeForm",
    staticClass: "freezeForm",
    attrs: {
      "labelPosition": "right",
      "btnPosition": "center",
      "btnLabel": false,
      "formList": _vm.freezeFormList,
      "values": _vm.freezeValues,
      "columns": _vm.columns,
      "buttonList": _vm.freezeButtonList,
      "formEnterIndex": 0
    },
    model: {
      value: (_vm.freezeValues),
      callback: function($$v) {
        _vm.freezeValues = $$v
      },
      expression: "freezeValues"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef557fbe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/NB/PeriodSetting.vue
// module id = 1808
// module chunks = 1